import Letterhead from "../Reusable/Letterhead2";
import MetaInfo from "../Reusable/MetaInfo2";
import SubjectLine from "../Reusable/SubjectLine2";
import Signature from "../Reusable/Signature2";



interface AppreciationLetterProps{
    refNo: string;
    date: string;
    name: string;
    address: string;
}

const AppreciationLetter=({refNo, date, name, address}: AppreciationLetterProps)=>(
    <div className="p-10 rounded-lg max-w-2xl mx-auto space-y-4">
    <Letterhead/>
    <hr className=" mx-auto w-4/4 border-t-2 border-black"/>
    <MetaInfo refNo={refNo} date={date} name={name} address={address} />
    <SubjectLine subject="Appreciation Letter" />

    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    We would like to take this opportunity to sincerely appreciate your continued efforts and dedication towards your role at Optim Health and Wellness Pvt. Ltd. Your consistent hardwork, commitment and positive approach have contributed significantly to the progress of
    your team and the organization.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    Your professionalism, reliability and willingness to take ownership of responsibilities are highly valued. 
    We truly recognize the impact of your contributions and encourage you to continue maintaining this level of performance.
    </p>
    <br/>
    <p className="text-[20px] px-8" style={{fontFamily: "Times New Roman"}}>
    Please accept this letter as a formal note of appreciation for your valuable work. We are
    confident that you will continue to grow with the organization and achieve greater milestones in the future.
    </p>

    <Signature />
  </div>
);
export default AppreciationLetter;